import React, { Fragment, useEffect, useState } from 'react';
import walkinImg from '../../../images/logoWithText.jpeg';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { getLoginDetails, getUserInfo } from '../../../constants/apiCalls';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import Storage from '../../../services/Storage';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionUser, getUserInfoDetail } from '../../../reducers/UserGetReducer';
import { Permissions } from '../../../constants/Permissions';

const Login = () => {
  const token = Storage.getTokenDetail() || {};
  const { permissionArr } = useSelector((state) => state.UserGetReducer);
  const localPermission = permissionArr;
  const [email, setEmail] = useState(0);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (token.accessToken) {
      if (localPermission.includes(Permissions.CNF_DASHBOARD)) {
        navigate('/cnf/cnf-dashboard');
        return;
      }

      navigate('/agrocel/dashboard');
    }
  }, []);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let form = {
      username: email,
      password: password,
      grant_type: 'password',
    };
    setIsloading(true);
    getLoginDetails((response) => {
      const {
        accessToken,
        accessTokenExpiresAt,
        error,
        refreshTokenExpiresAt,
        user,
      } = response;
      if (refreshTokenExpiresAt) {
        let obj = {
          accessToken: response.accessToken,
          accessTokenExpiresAt: response.accessTokenExpiresAt,
          refreshToken: response.refreshToken,
          refreshTokenExpiresAt: response.refreshTokenExpiresAt,
        };
        Storage.setTokenDetail(obj);
      }
      if (accessToken) {
        Storage.setAccessToken(accessToken);
        Storage.setRefreshTokenExpiresAt(accessTokenExpiresAt);
        Storage.setUserInfoDetail(user);
        getUserInfo((res) => {
          const { data, success } = res;
          if (success === true) {
            // Storage.setUserPermissionDetail(data.permissions);
            dispatch(getUserInfoDetail(data));
            dispatch(getPermissionUser(data.permissions));
            setIsloading(false);
            if (data.permissions.includes(Permissions.CNF_DASHBOARD)) {
              navigate('/cnf/cnf-dashboard');
              // navigate('/agrocel/dashboard');
            } else {
              navigate('/agrocel/dashboard');
            }
          } else if (success === false || success === 'undefined') {
            setIsloading(false);
            ModalService.openAlert(
              '',
              handleErrorMessage(error[0].message),
              'error',
            );
          }
          setIsloading(false);
        });
      } else {
        setIsloading(false);
      }
    }, form);
  };

  return (
    <Fragment>
      <div id="Login">
        <Row className="no-gutters main-row">
          <Col lg="4" className=" bg-white powered-by"></Col>
          <Col
            lg="8"
            md="12"
            className=" d-flex bg-white justify-content-center align-items-center"
          >
            <hr className=" vertical-line bg-white" />
            <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
              <div />
              <div className="logo">
                <img className="logo-img img-fluid" src={walkinImg} alt="" />
              </div>
              <h4 className="mb-0">
                {/* <div className='welcome'>Welcome back,</div> */}
                <span className="sign-in-text">
                  Please sign in to your account.
                </span>
              </h4>
              {/* <h6 className="mt-3">
                No account? <Link className="text-primary">Sign up now</Link>
              </h6> */}
              <Row className="divider" />
              <div>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">
                          Email<span className="required">*</span>
                        </Label>
                        <Input
                          type="email"
                          name="email"
                          onChange={(e) => setEmail(e.target.value)}
                          id="exampleEmail"
                          placeholder="Email here..."
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="examplePassword">
                          Password<span className="required">*</span>
                        </Label>
                        <Input
                          type="password"
                          name="password"
                          onChange={(e) => setPassword(e.target.value)}
                          id="examplePassword"
                          placeholder="Password here..."
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup check>
                    <Input type="checkbox" name="check" id="exampleCheck" />
                    <Label for="exampleCheck" check>
                      Keep me logged in
                    </Label>
                  </FormGroup>
                  <Row className="divider" />
                  <div className="d-flex align-items-center">
                    <div className="ml-auto">
                      <span
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        className="btn-lg btn btn-link"
                        onClick={() => navigate('/user/forgot-password')}
                      >
                        Recover Password
                      </span>
                      <Button
                        className="login-btn"
                        style={{
                          borderRadius: '18px',
                          fontWeight: '600',
                          textAlign: 'center',
                          padding: '10px 40px',
                        }}
                        size="lg"
                        type='submit'
                      >
                        Login
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Col>
        </Row>
        {isLoading && <CustomSpinner />}
      </div>
    </Fragment>
  );
};
export default Login;
